let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eZGmx")).then(() => parcelRequire('4aDUk'));